import React, { useEffect, useCallback } from 'react';
import '../Styles/EmploymentLawDialog.scss';

const EmploymentLawDialog = ({ 
  isOpen, 
  employmentLawName, 
  employmentLawTitle, 
  employmentLawDetail, 
  onClose 
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div className="employment-law-dialog-overlay" onClick={handleBackdropClick}>
      <div className="employment-law-dialog-container">
        <div className="employment-law-dialog-header">
          <div className="employment-law-dialog-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="14,2 14,8 20,8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="16" y1="13" x2="8" y2="13"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="16" y1="17" x2="8" y2="17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <polyline
                points="10,9 9,9 8,9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <h2 className="employment-law-dialog-title">{employmentLawName}</h2>
          <button 
            className="employment-law-dialog-close" 
            onClick={onClose}
            aria-label="Fermer"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path 
                d="M15 5L5 15M5 5L15 15" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
        
        <div className="employment-law-dialog-content">
          {employmentLawTitle && (
            <div className="employment-law-section">
              <h4 className="employment-law-subtitle">{employmentLawTitle}</h4>
            </div>
          )}
          
          {employmentLawDetail && (
            <div className="employment-law-detail">
              <pre className="employment-law-text">{employmentLawDetail}</pre>
            </div>
          )}
        </div>
        
        <div className="employment-law-dialog-actions">
          <button 
            className="employment-law-dialog-button employment-law-dialog-button--primary" 
            onClick={onClose}
            autoFocus
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="button-icon">
              <path
                d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"
                fill="currentColor"
              />
            </svg>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmploymentLawDialog;